import React, { useEffect } from "react";
import { orgActions } from "../../actions";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

function PageTypesNav(props) {
  const { org, getScrapeInfo, parent } = props;
  const current_org_id = Number(org.current_org_id);

  useEffect(() => {
    getScrapeInfo(current_org_id);
  }, [current_org_id]);

  return (
    <>
      <Link to={"/org/" + current_org_id + "/pagetypes/"} class="navLink">
        <span
          className={`leftNavElement ${
            parent === "pagetypes" ? "bluearrow" : "mediumgreenarrow"
          }`}
        >
          inspect
        </span>
      </Link>
      <br />
      <Link to={"/org/" + current_org_id + "/pagetypes/groups"} class="navLink">
        <span
          className={`leftNavElement ${
            parent === "groups" ? "bluearrow" : "mediumgreenarrow"
          }`}
        >
          groups
        </span>
      </Link>
    </>
  );
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const actionCreators = {
  getScrapeInfo: orgActions.getScrapeInfo,
};

const connectedPageTypesNav = connect(
  mapStateToProps,
  actionCreators
)(PageTypesNav);
export { connectedPageTypesNav as PageTypesNav };
